module.exports = __webpack_public_path__ + "img/game_phone_usdt.e976740b.png";